import { memo, useEffect } from "react";

const HeaderAdd = () => {
  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {}
  }, []);
  return (
    <div className="header-ad">
      <ins
        className="adsbygoogle"
        style={{ display: "block", marginBottom: "12px" }}
        data-ad-client="ca-pub-7062721784935312"
        data-ad-slot="6368583674"
        data-ad-format="auto"
        data-full-width-responsive="true"
      ></ins>
    </div>
  );
};

export default memo(HeaderAdd);
